
import React, { Component } from 'react';
import moment from 'moment';

import pr from '../assets/pr.png';

class ActivityRow extends Component {
  limitChars(string) {
    if(!string) return;
    if(string.length > 39) {
      return string.slice(0, 30) + '...';
    }
    return string;
  }

  limitDesc(string) {
    if(!string) return;
    if(string.length > 30) {
      return string.slice(0, 30) + '...';
    }
    return string
  }

  checkIfFirstTimePR(string) {
    if(string.indexOf('-') > -1) {
      return string + ' (First Time)';
    }
    return string;
  }

  render() {

    let ourDate = moment(this.props.activity.created_at);

    return (
      <div className={'activity-row relative pt4 pb1 ph4 w-25 tl flex flex-wrap justify-center items-top' + (ourDate.isSame(moment(), 'day') ? ' gold' : '')}>
        <div className="w-100">
          <div className="flex">
            <div className="image">
              <div className="aspect-ratio aspect-ratio--1x1">
                <div 
                  className="aspect-ratio--object cover br-100 z-1"
                  style={{
                    'backgroundImage': 'url(' + this.props.activity.member_image + ')',
                    'backgroundColor': '#d0d2d3'
                  }}>
                </div>
              </div>
            </div>

            <div className="fix-image-name pl2 w-80">
              <h2 className="name mb1 text-capitalize ttc f4">{this.props.activity.member_name}</h2>
              <p className="ma0 t-dark-gray">{ourDate.format('MMM DD, YYYY')}</p>
            </div>
          </div>
          <div className="db center name-date w-100">
            <p className="title mb1 mt3 f4 fw6">{this.limitDesc(this.props.activity.workout_name)}</p>

            {this.props.activity.notes &&
              <p className="notes h2 f5 mt2 mb0 overflow-hidden">{this.props.activity.notes}</p>
            }
            <h4 className="score mt2 mb1 f4 tc t-blue">{this.limitChars(this.props.activity.score)}</h4>
            <p className="score pr mt1 pa0 pl0 f4 tc">
              <span className="t-green ma0 pv0 f5 ph3">{this.props.activity.prior_difference ? this.checkIfFirstTimePR(this.props.activity.prior_difference) : '-'} </span>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default ActivityRow;


// WEBPACK FOOTER //
// ./src/components/ActivityRow.js